<template>
  <div class="loginHeader">
    <img
      src="@img/login/logo.png"
      @click="logoClick"
      class="header-logo"
      alt="logo"
    />
 
  <slot class="smloginHeader" name="tabs"></slot>
    <div class="smloginHeader"  style="flex: 1">
       康吉森工业互联网平台
    </div>
    <div class="appDownload" name="right">
      <el-popover
        trigger="hover"
      > 
        <div style="display: flex;">
          <div style="display: flex; flex-direction: column; align-items: center;">
            <span>安卓</span>
            <img
              src="@/assets/images/android.png"
              class="app-download"
              alt="安卓"
            />
          </div>
          <div style="display: flex; flex-direction: column; align-items: center;">
            <span>IOS</span>
            <img
              src="@/assets/images/ios.png"
              class="app-download"
              alt="IOS"
            />
          </div>
        </div>
        <span slot="reference">APP下载</span>
      </el-popover>
    </div>


  </div>
  
 
</template>

<script>
export default {
  methods: {
    logoClick() {
      this.$emit("logoClick");
    },
  },
};
</script>

<style scoped lang="less">
.loginHeader {
  height: 79px;
  line-height: 79px;
  padding: 33px 200px;
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  color: #252525;
  font-weight: 600;
  .header-logo {
    cursor: pointer;
    width: 79px;
    height: 41px;
  }

  & > span {
    display: inline-block;
    height: 100%;
  }
  .project-logo {
    cursor: pointer;
    .iconIoT {
      font-size: 32px;
      color: @c-primary;
      vertical-align: middle;
    }
  }
  .project-name {
    font-weight: bold;
    color: #040c2c;
    letter-spacing: 1px;
    line-height: 58px;
    font-size: 20px;
    cursor: pointer;
  }
}
.appDownload{
  cursor: pointer;
  /deep/.el-popover{
    .download{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}
.app-download{
  width: 154px;
  height: 154px;
}
@media screen and (max-width: 992px) {
    .smloginHeader{
      //  display: none;
    }
    // .loginHeader{
    //   width: 200px;
    // }
    
  }
</style>